// @flow
import { call, put, takeLatest } from "redux-saga/effects";
import API from "api";

import * as ActionTypes from 'constants/ActionTypes';
import * as Actions from "actions";

const querystring = require('querystring');

// Start website scan
function* adminStartWebsiteScan(action: Object) {
    try {
        const { url, config, callback } = action;

        const response = yield API.post(
            `/admin/website-scraper/start-scan`,
            { url, config }
        );

        yield put(Actions.adminStartWebsiteScanSuccess(response));
        if (callback) callback(null, response);
    } catch (error) {
        yield put(Actions.adminStartWebsiteScanFailure(error));
        if (action.callback) action.callback(error);
    }
}

// Quick scan
function* adminQuickScan(action: Object) {
    try {
        const { url, callback } = action;

        const response = yield API.post(
            `/admin/website-scraper/quick-scan`,
            { url }
        );

        yield put(Actions.adminQuickScanSuccess(response));
        if (callback) callback(null, response);
    } catch (error) {
        yield put(Actions.adminQuickScanFailure(error));
        if (action.callback) action.callback(error);
    }
}

// Get scan status
function* adminGetScanStatus(action: Object) {
    try {
        const { scanId } = action;

        const response = yield API.get(`/admin/website-scraper/scan-status/${scanId}`);

        yield put(Actions.adminGetScanStatusSuccess(response));
    } catch (error) {
        yield put(Actions.adminGetScanStatusFailure(error));
    }
}

// Get scan results
function* adminGetScanResults(action: Object) {
    try {
        const { scanId } = action;

        const response = yield API.get(`/admin/website-scraper/scan-results/${scanId}`);

        yield put(Actions.adminGetScanResultsSuccess(response));
    } catch (error) {
        yield put(Actions.adminGetScanResultsFailure(error));
    }
}

// Get scraped products
function* adminGetScrapedProducts(action: Object) {
    try {
        const { domain, options = {} } = action;
        
        const params = querystring.stringify({
            limit: options.limit || 50,
            skip: options.skip || 0,
            sort: options.sort || 'created_at',
            sort_order: options.sort_order || 'desc'
        });

        const response = yield API.get(`/admin/website-scraper/products/${domain}?${params}`);

        yield put(Actions.adminGetScrapedProductsSuccess(response));
    } catch (error) {
        yield put(Actions.adminGetScrapedProductsFailure(error));
    }
}

// Get scanned domains
function* adminGetScannedDomains(action: Object) {
    try {
        const response = yield API.get(`/admin/website-scraper/domains`);

        yield put(Actions.adminGetScannedDomainsSuccess(response));
    } catch (error) {
        yield put(Actions.adminGetScannedDomainsFailure(error));
    }
}

// Get scan history
function* adminGetScanHistory(action: Object) {
    try {
        const { domain, limit } = action;
        
        const params = querystring.stringify({
            limit: limit || 10
        });

        const response = yield API.get(`/admin/website-scraper/scan-history/${domain}?${params}`);

        yield put(Actions.adminGetScanHistorySuccess(response));
    } catch (error) {
        yield put(Actions.adminGetScanHistoryFailure(error));
    }
}

// Cancel scan
function* adminCancelScan(action: Object) {
    try {
        const { scanId, callback } = action;

        const response = yield API.post(`/admin/website-scraper/cancel-scan/${scanId}`);

        yield put(Actions.adminCancelScanSuccess(response));
        if (callback) callback(null, response);
    } catch (error) {
        yield put(Actions.adminCancelScanFailure(error));
        if (action.callback) action.callback(error);
    }
}

// Delete scraped products
function* adminDeleteScrapedProducts(action: Object) {
    try {
        const { domain, callback } = action;

        const response = yield API.delete(`/admin/website-scraper/products/${domain}`);

        yield put(Actions.adminDeleteScrapedProductsSuccess(domain, response.modified_count));
        if (callback) callback(null, response);
    } catch (error) {
        yield put(Actions.adminDeleteScrapedProductsFailure(error));
        if (action.callback) action.callback(error);
    }
}

// Get scraped product by ID
function* adminGetScrapedProduct(action: Object) {
    try {
        const { productId } = action;

        const response = yield API.get(`/admin/website-scraper/product/${productId}`);

        yield put(Actions.adminGetScrapedProductSuccess(response));
    } catch (error) {
        yield put(Actions.adminGetScrapedProductFailure(error));
    }
}

// Watchers
export default function* adminWebsiteScraperSaga(): Generator<*, *, *> {
    yield takeLatest(ActionTypes.ADMIN_START_WEBSITE_SCAN_START, adminStartWebsiteScan);
    yield takeLatest(ActionTypes.ADMIN_QUICK_SCAN_START, adminQuickScan);
    yield takeLatest(ActionTypes.ADMIN_GET_SCAN_STATUS_START, adminGetScanStatus);
    yield takeLatest(ActionTypes.ADMIN_GET_SCAN_RESULTS_START, adminGetScanResults);
    yield takeLatest(ActionTypes.ADMIN_GET_SCRAPED_PRODUCTS_START, adminGetScrapedProducts);
    yield takeLatest(ActionTypes.ADMIN_GET_SCANNED_DOMAINS_START, adminGetScannedDomains);
    yield takeLatest(ActionTypes.ADMIN_GET_SCAN_HISTORY_START, adminGetScanHistory);
    yield takeLatest(ActionTypes.ADMIN_CANCEL_SCAN_START, adminCancelScan);
    yield takeLatest(ActionTypes.ADMIN_DELETE_SCRAPED_PRODUCTS_START, adminDeleteScrapedProducts);
    yield takeLatest(ActionTypes.ADMIN_GET_SCRAPED_PRODUCT_START, adminGetScrapedProduct);
}
